import {
	defAction
}from "../../../../helpers/defaultAction"
import api from './api'
import {
	reSpecificWeightConstants
}from "./constants"
import downloadFile from "../../../../helpers/downloadFile"

export const reSpecificWeightActions = {
	getKinds,
	getList,
	getPaged,
	getExampleFile,
	upload,
	clear
}

function clear(){
	return (dispatch) => dispatch({
		type: reSpecificWeightConstants.CLEAR
	})
}

function upload(values){
	const dispatchObj = {
		constants : reSpecificWeightConstants.Upload,
		service   : {
			func   : api.upload,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getExampleFile(){
	const dispatchObj = {
		constants : reSpecificWeightConstants.GetExampleFile,
		service   : {
			func: api.getExampleFile
		},
		sucFunction: (res) => downloadFile(res, "Шаблон.xlsx")
	}
	return defAction(dispatchObj)
}

function getPaged(values){
	const dispatchObj = {
		constants : reSpecificWeightConstants.GetPaged,
		service   : {
			func   : api.getPaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getKinds(values){
	const dispatchObj = {
		constants : reSpecificWeightConstants.GetKinds,
		service   : {
			func   : api.getKinds,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getList(values){
	const dispatchObj = {
		constants : reSpecificWeightConstants.GetList,
		service   : {
			func   : api.getList,
			params : values
		}
	}
	return defAction(dispatchObj)
}